import Vue from 'vue';
import Vuex from 'vuex';
import {
  getStoreList,
  getUserInfo,
  Sign,
  Exchange,
} from '@/api/';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    toastMsg: '',
    toastShow: false,
    loadingShow: false,
    page: 1,
  },
  mutations: {
    /* eslint no-param-reassign: "error" */
    setState(state, data) {
      if (data.obj) {
        data.obj[data.key] = data.val;
      } else {
        Object.keys(data).forEach((key) => {
          if (key in state) state[key] = data[key];
        });
        // state[data.key] = data.val;
      }
    },
    showToast(state, msg) {
      clearTimeout(state.setTime);
      state.toastMsg = msg;
      state.toastShow = true;
      state.setTime = setTimeout(() => {
        state.toastShow = false;
      }, 3500);
    },
  },
  actions: {
    getStoreListFn({ commit }) {
      getStoreList().then((res) => {
        const { store: storeList } = res.data;
        commit('setState', { storeList: storeList.sort((a, b) => b.honey - a.honey) });
      });
    },
    getUserInfoFn({ commit, state }) {
      const param = {
        uid: state.uid,
        token: state.token,
      };
      getUserInfo(param).then((res) => {
        if (res.error_code === 1) {
          const { SignDays: signDays, status, honey } = res.data;
          commit('setState', { signDays, status, honey });
        }
      });
    },
    signFn({ commit, state, dispatch }) {
      if (state.status) return;
      const param = {
        uid: state.uid,
        token: state.token,
      };
      Sign(param).then((res) => {
        commit('showToast', res.msg);
        dispatch('getUserInfoFn');
      });
    },
    exchangeFn({ commit, state, dispatch }, id) {
      const param = {
        uid: state.uid,
        token: state.token,
        id,
        count: 1,
      };
      Exchange(param).then((res) => {
        if (res.msg === '兑换失败，当前蜂蜜数不足') {
          commit('setState', { promptShow: true });
        } else {
          commit('showToast', res.msg);
          dispatch('getUserInfoFn');
        }
      });
    },
    rechargeFn({ commit }) {
      commit('setState', { promptShow: true });
    },
  },
  modules: {
  },
});
